import React, { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import './App.css';
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  onSnapshot,
  orderBy,
  query,
  addDoc
} from "firebase/firestore";
import ReactPlayer from "react-player";
import db from "./services/firebase";
import Aleatorio from "./api/Aleatoria";

function App() {
  const [playlist, setPlaylist] = useState([]);
  const [currentUrl, setCurrentUrl] = useState("");
  const [systemOff, setSystemOff] = useState(false);
  const isFetchingRef = useRef(false); // evita fetch duplicado
  const [contador, setContador] = useState(0); // [1]
  const [isTransitioning, setIsTransitioning] = useState(false);
  const MAX_VIDEOS_BEFORE_RELOAD = 10;
  useEffect(() => {
    const checkStartStatus = async () => {
      const startRef = doc(db, "start", "start");
      const startSnap = await getDoc(startRef);

      if (startSnap.exists() && startSnap.data().start === 0) {
        setSystemOff(true);
      } else {
        setSystemOff(false);
        loadPlaylist(); // só chama aqui
      }
    };

    checkStartStatus();

    const unsubscribe = onSnapshot(doc(db, "start", "start"), (docSnap) => {
      if (docSnap.exists() && docSnap.data().start === 0) {
        setSystemOff(true);
      } else {
        setSystemOff(false);
        // NÃO chama loadPlaylist aqui!
      }
    });

    return () => unsubscribe();
  }, []);

  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const loadPlaylist = async () => {
    setContador(prev => prev + 1);
    const videosRef = collection(db, "lista");
    const q = query(videosRef, orderBy("fecha", "asc"));
    console.log(contador)
    const unsubscribe = onSnapshot(q, async (snapshot) => {
      const newVideos = snapshot.docs.map((doc) => ({
        id: doc.id,
        url: `https://www.youtube.com/watch?v=${doc.data().id}`,
        thumb: `https://i.ytimg.com/vi/${doc.data().id}/hqdefault.jpg`,
        title: doc.data().title || "",
        affil: doc.data().author || "JUSCEIR",
        current: false,
      }));
      if (newVideos.length > 0) {
        newVideos[0].current = true;
        setPlaylist([...newVideos]);
        setCurrentUrl(newVideos[0].url);
      } else {
        await sleep(1000); // espera 1 segundo
        //chamar firebase para buscar novo vídeo
        await fetchNewVideo();
      }
    });

    return () => unsubscribe();
  };

  const fetchNewVideo = async () => {
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;

    try {
      let aleatorio;
      let attempts = 0;

      do {
        aleatorio = await Aleatorio();
        attempts++;
        if (attempts > 5) return;
      } while (
          !aleatorio.video_id ||
          `https://www.youtube.com/watch?v=${aleatorio.video_id}` === currentUrl
          );

      const video = {
        id: aleatorio.video_id,
        url: `https://www.youtube.com/watch?v=${aleatorio.video_id}`,
        thumb: `https://i.ytimg.com/vi/${aleatorio.video_id}/hqdefault.jpg`,
        title: aleatorio.video_title || "",
        author: "Aleatorio",
        fecha: Date.now(),
        current: false,
      };

      if (playlist.length <= 2) {
        await addDoc(collection(db, "lista"), video);
      }
    } catch (err) {
      console.error("Erro ao buscar novo vídeo:", err);
    } finally {
      isFetchingRef.current = false;
    }
  };

  const handleEnded = async () => {
    if (playlist.length > 0) {
      setIsTransitioning(true);

      const currentIndex = playlist.findIndex((v) => v.url === currentUrl);
      const nextIndex = (currentIndex + 1) % playlist.length;
      const nextVideo = playlist[nextIndex];

      // Dá tempo da animação rodar antes de trocar
      setTimeout(async () => {
        setPlaylist(
            playlist.map((video, index) => ({
              ...video,
              current: index === nextIndex,
            }))
        );
        setCurrentUrl(nextVideo.url);

        await deleteDoc(doc(db, "lista", playlist[currentIndex].id));
        setIsTransitioning(false);

        // 👉 Incrementa o contador e verifica se chegou a 10
        setContador((prev) => {
          const novoValor = prev + 1;
          if (novoValor >= 10) {
            console.log("Assistiu 10 vídeos. Recarregando a página...");
            window.location.reload();
          }
          return novoValor;
        });
      }, 1000);
    }
  };


  if (systemOff) {
    return (
        <div className="system-off">
          <h1>Por favor, ligue o sistema pelo aplicativo.</h1>
        </div>
    );
  }

  return (
      <div className="app">
        <div className="player-container">
          <AnimatePresence>
            {isTransitioning && (
                <motion.div
                    className="transition-overlay"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.8 }}
                >
                  <motion.img
                      src="https://i.ibb.co/yBqWSbBN/apemlogo.png"
                      alt="Transição"
                      initial={{ scale: 1 }}
                      animate={{ scale: 1.05 }}
                      exit={{ scale: 1 }}
                      transition={{ duration: 0.8, ease: "easeInOut" }}
                      className="transition-image"
                  />
                </motion.div>
            )}
          </AnimatePresence>
          <motion.div
              className="propaganda-1"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.9 }}
          >
            <img
                style={{ marginTop: 10 }}
                width={"100%"}
                src="https://mundonegro.inf.br/wp-content/uploads/2011/10/BANER-1400.jpg"
                alt=""
            />
          </motion.div>

          <Player
              url={currentUrl}
              handleEnded={handleEnded}
              playerlist={playlist}
              fetchNewVideo={fetchNewVideo}
          />

          <motion.div
              className="propaganda-2"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.9 }}
          >
            <img
                width={"100%"}
                src="https://mundonegro.inf.br/wp-content/uploads/2011/10/BANER-1400.jpg"
                alt=""
            />
          </motion.div>
        </div>

        <div className="playlist-right">
          <Playlist playlist={playlist} />
        </div>
      </div>
  );
}

const Player = ({ url, handleEnded, playerlist, fetchNewVideo }) => {
  const [progress, setProgress] = useState(0);
  const [seeking, setSeeking] = useState(false);
  const passedRef = useRef(false);

  const handleProgress = async (state) => {
    if (!seeking) {
      setProgress(state.played * 100);

      const isLastVideo =
          playerlist.length > 0 &&
          playerlist[playerlist.length - 1].url === url;

      if (state.played * 100 >= 90 && isLastVideo && !passedRef.current) {
        passedRef.current = true;
        await fetchNewVideo();
      }
    }
  };

  return (
      <motion.div
          className="player-wrapper"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.9 }}
      >
        <ReactPlayer
            url={url}
            playing={true}
            controls={false}
            width="100%"
            height="100%"
            onProgress={handleProgress}
            onEnded={handleEnded}
        />
      </motion.div>
  );
};

const Playlist = ({ playlist }) => {
  return (
      <div className="playlist-container">
        {playlist.map((video, index) => (
            <motion.div
                key={video.id}
                className={`video ${video.current ? "current" : ""}`}
                initial={{ transform: "translateX(120%)" }}
                animate={{ transform: "translateX(0%)" }}
                transition={{
                  duration: 0.5,
                  delay: 0.1 * index,
                }}
                style={{
                  backgroundColor: video.current ? "#fbe102" : "#0F0D1E",
                }}
            >
              <div className="image">
                <img src={video.thumb} alt={video.title} />
              </div>
              <div className="video-info">
                <span className="title">{video.title}</span>
                <span className="affil">Por: {video.affil}</span>
              </div>
            </motion.div>
        ))}
      </div>
  );
};

export default App;
